module.exports = __webpack_public_path__ + "static/media/close-black.2214ad11.svg";